const configAttributes = [
  ['ownerDirectory', 'data-owner-id'],
  ['theme', 'data-theme'],
  ['title', 'data-title'],
  ['iframeUrl', 'src']
];

function getConfig(baseElement) {
  return configAttributes.reduce((acc, tuple) => {
    acc[tuple[0]] = baseElement.getAttribute(tuple[1]);

    return acc;
  }, {});
}

const messageHandler = (iframe, script, iframeNumber) => e => {

  switch (e.data?.type) {
  case 'rv-rentals-widget:ready':
    iframe.contentWindow.postMessage({
      type: 'rv-rentals-widget:config',
      payload: {
        ...getConfig(script),
        ownerPageUrl: { 
          href: window?.location?.href,
          pathname: window?.location?.pathname,
          origin: window?.location?.origin,
        },
        iframeNumber
      }
    }, '*');
    break;
    case 'rv-rentals-widget:iframe-height':
      const iframeNum = e?.data?.iframeNumber
      const ifr = document.getElementById(`white-label-owner-iframe-${iframeNum}`);

      if (ifr) {
        ifr.style.height = e?.data?.height
      }

      const spinner = document.getElementById(`spinner-${iframeNum}`);

      if (spinner) {
        spinner.style.display = "none"
      }

      break;
    default:
      break;
    }
};

export default messageHandler;
